<template>
    <app-layout :racingstars="$page.props.racingstars" :jetstream="$page.props.jetstream" :user="$page.props.user" title="Dashboard">
        <template #header>
            Friends
        </template>
        <div class="flex flex-col lg:grid lg:grid-cols-2 lg:gap-4 lg:w-2/3 w-4/5 mx-auto bg-gray-900 text-white lg:py-5 lg:px-6 lg:shadow transition duration-500 ease-in-out rounded-lg border-2 border-gray-600 p-6 lg:p-4 m-4">
            <div class="lg:border-r p-2 pr-4">
                <dl :class="friendRequestsCount === 0 ? 'hidden' : 'mb-4'">
                    <span class="flex mx-auto text-center justify-center mb-2">
                        <UserAddIcon class="w-6 mr-2 my-auto"/>
                        <h1 class="text-white text-xl text-center">Friend Requests ({{friendRequestsCount}})</h1>
                    </span>
                    <Disclosure  as="div"  v-slot="{ open }" >
                        <dt class="text-lg" >
                            <div class="flex justify-between bg-gray-600 rounded-md p-2 border-2 border-gray-400 my-2" v-for="friendRequest in friendRequests" :key="friendRequest.id">
                                <span class="my-auto text-sm xl:text-base p-1 pr-2 capitalize">{{friendRequest.user.name}}</span>
                                <div class="flex flex-col fold:flex-row my-auto">
                                    <button class="lg:mx-3 px-1 py-1 text-xs lg:text-sm font-medium mr-4 text-green-500 w-8 my-auto stroke-current border rounded-full hover:bg-green-800" @click="accept(friendRequest.sender_id)"><CheckIcon class=""/></button>
                                    <button class="px-1 py-1 text-xs lg:text-sm font-medium mr-1 text-red-500 w-8 my-auto stroke-current border rounded-full hover:bg-red-800" @click="deny(friendRequest.sender_id)"><XIcon/></button>
                                </div>
                            </div>
                        </dt>
                    </Disclosure>
                </dl>
                <span class="flex mx-auto text-center justify-center">
                    <SearchIcon class="w-6 mr-2"/>
                    <p class="text-white text-xl text-center my-2"> Search </p>
                </span>
                <input class="flex mx-auto text-black rounded-md w-full mb-4" type="text" v-model="query" @input="search(query)" />
                <ul>
                    <li v-for="(findUser) in findUsers" :key="findUser.status" class="flex justify-between my-2 bg-gray-600 rounded-md p-2 border-2 border-gray-400">
                        <div class="shrink-0 h-10 w-10">
                            <img class="rounded-full h-10 w-10 object-cover" :src="findUser.profile_photo_url"/>
                        </div>
                        <span class="my-auto text-sm xl:text-base capitalize">
                        {{ findUser.username }}

                        </span>
                        <button v-if="findUser.status == null"  class="yellow-button" @click="addFriend(findUser)">Add</button>
                        <button v-else class="yellow-button !bg-blue-700 disabled">
                            <ClockIcon class="h-6 w-6 text-center text-white m-auto" aria-hidden="true"/>
                        </button>
                    </li>
                </ul>
            </div>

            <div class="pl-0">
                <div class="pl-0 col-start-2">
                    <span class="flex mx-auto text-center justify-center">
                        <UsersIcon class="w-6 mr-2 my-auto"/>
                        <p class="text-white text-xl text-center my-2"> My Friends ({{friendCount}})</p>
                    </span>
                    <div v-for="friend in friends" :key="friend.id" class="flex justify-between my-2 bg-gray-600 rounded-md p-2 border-2 border-gray-400">
                        <!-- <div class="shrink-0 h-10 w-10">
                            <img class="rounded-full h-10 w-10 object-cover bg-white" />
                        </div> -->
                        <p class="text-sm xl:text-base mx-auto my-auto h-full capitalize">{{friend.username}}</p>
                    </div>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/Layout'
import { UsersIcon, SearchIcon, CheckIcon, XIcon, InformationCircleIcon, UserAddIcon, CheckCircleIcon, ClockIcon } from '@heroicons/vue/outline'
import Popper from 'vue3-popper'
import TwButton from "../../Global/Elements/TwButton.vue";
import {Disclosure, DisclosureButton} from "@headlessui/vue";
import {ref} from "vue";

export default {
    props: {
        findUsers: {
            type: Object,
        },
        friends: {
            type: Object,
            default: {},
        },
        friendRequests: {
            type: Object,
            default: {},
        },
        friendRequestsCount: {
            type: Number,
            default: 0,
        },
        friendCount: {
            type: Number,
            default: 0,
        },
    },
    components: {
        DisclosureButton,
        Disclosure,
        TwButton,
        AppLayout,
        Popper,
        UsersIcon,
        SearchIcon,
        CheckCircleIcon,
        ClockIcon,
        CheckIcon,
        XIcon,
        InformationCircleIcon,
        UserAddIcon,
    },

    setup(props) {


        // function addFriend(finduser) {
        //     axios.post(route('friend.add'), {
        //         user_id: finduser.id
        //     }).then(function(response) {
        //         findUser.status = 'pending'
        //         console.log(findUser.status)
        //     });
        // }

        function addFriend(findUser) {
            axios.post(route('friend.add', {user_id: findUser.id}, {  user_id: findUser.id })).then(function(response) {
                findUser.status = 'pending'
            });
        }


        const accept = (id) => {
            axios.post(route('friend.accept'), {
                user_id: id
            })
        }
        const deny = (id) => {
            axios.post(route('friend.deny'), {
                user_id: id
            })
        }
        const query = ref('');
        let findUsers = ref({})
        const search = (query) => {
            axios.post(route('friend.search'), {
                name: query
            }).then((response) => {
                findUsers.value = response.data
                console.log(findUsers)
            })
        }
        return {
            accept,
            deny,
            addFriend,
            search,
            findUsers,
            query
        }
    }

}
</script>
